export const PRESS_ROOM_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "CollectionPage",
   "@id": "https://everest.ind.br/pt/sala-de-imprensa/#webpage",
   "name": "Sala de Imprensa | Destaques | Everest",
   "url": "https://everest.ind.br/pt/sala-de-imprensa",
   "description": "Veja quais são as principais matérias e destaques da mídia sobre a Everest, marca referência em purificadores e filtros de água com 50 anos no mercado.",
   "inLanguage": "pt-BR",
   "isPartOf": {
    "@id": "https://everest.ind.br/#website"
   },
   "publisher": {
    "@id": "https://everest.ind.br/#organization"
   },
   "about": {
    "@id": "https://everest.ind.br/#organization"
   },
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/sala-de-imprensa/#breadcrumb"
   },
   "mainEntity": {
    "@id": "https://everest.ind.br/pt/sala-de-imprensa/#press-list"
   },
   "potentialAction": {
    "@type": "ViewAction",
    "name": "Ir para o e-commerce Everest",
    "target": {
     "@type": "EntryPoint",
     "urlTemplate": "https://www.compraeverest.com.br/",
     "actionPlatform": [
      "http://schema.org/DesktopWebPlatform",
      "http://schema.org/MobileWebPlatform"
     ]
    }
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/sala-de-imprensa/#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Sala de Imprensa",
     "item": "https://everest.ind.br/pt/sala-de-imprensa"
    }
   ]
  },
  {
   "@type": "ItemList",
   "@id": "https://everest.ind.br/pt/sala-de-imprensa/#press-list",
   "name": "Releases e Destaques na Mídia",
   "description": "Lista de conteúdos institucionais, notícias e publicações sobre a Everest na mídia.",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "item": {
      "@type": "NewsArticle",
      "name": "ESG da Everest apoia conservação dos recursos hídricos no Pantanal",
      "description": "Parceria com SOS Pantanal visa patrocinar ações de preservação para o bioma e comunidades locais.",
      "url": "https://exame.com/bussola/esg-da-everest-alia-expertise-em-agua-ao-apoio-para-conservacao-dos-recursos-hidricos-no-pantanal/",
      "datePublished": "2024-08-15",
      "publisher": {
       "@type": "Organization",
       "name": "Exame",
       "url": "https://exame.com"
      },
      "mentions": {
       "@id": "https://everest.ind.br/#organization"
      }
     }
    },
    {
     "@type": "ListItem",
     "position": 2,
     "item": {
      "@type": "NewsArticle",
      "name": "Campanha com Sabrina Sato e focas geradas por IA é aposta da Everest para aumentar vendas em até 20%",
      "description": "Filme publicitário estreia hoje. Animais gerados e animados visam mostrar qualidade dos seus purificadores de água e foco da empresa na sustentabilidade.",
      "url": "https://exame.com/bussola/campanha-com-sabrina-sato-e-focas-geradas-por-ia-e-aposta-da-everest-para-aumentar-vendas-em-ate-20/",
      "datePublished": "2024-06-27",
      "publisher": {
       "@type": "Organization",
       "name": "Exame",
       "url": "https://exame.com"
      },
      "mentions": {
       "@id": "https://everest.ind.br/#organization"
      }
     }
    },
    {
     "@type": "ListItem",
     "position": 3,
     "item": {
      "@type": "NewsArticle",
      "name": "Influenciadores digitais se unem em parceria de marketing",
      "description": "Carol Peixinho, Aline Becker, Dalton Rangel, Duda Senna, Bruno Rezende e Rafa Kalimann foram os escolhidos para criar conexões com o público.",
      "url": "https://istoe.com.br/influenciadores-digitais-se-unem-em-parceria-de-marketing",
      "datePublished": "2024-07-01",
      "publisher": {
       "@type": "Organization",
       "name": "IstoÉ",
       "url": "https://istoe.com.br"
      },
      "mentions": {
       "@id": "https://everest.ind.br/#organization"
      }
     }
    },
    {
     "@type": "ListItem",
     "position": 4,
     "item": {
      "@type": "NewsArticle",
      "name": "4 histórias que vão te animar e te encorajar a mergulhar no empreendedorismo",
      "url": "https://exame.com/bussola/4-historias-que-vao-te-animar-e-te-encorajar-a-mergulhar-no-empreendedorismo/",
      "datePublished": "2024-02-14",
      "publisher": {
       "@type": "Organization",
       "name": "Exame",
       "url": "https://exame.com"
      },
      "mentions": {
       "@id": "https://everest.ind.br/#organization"
      }
     }
    },
    {
     "@type": "ListItem",
     "position": 5,
     "item": {
      "@type": "NewsArticle",
      "name": "Everest faturou mais de 30% nos primeiros quinze dias de 2024",
      "url": "https://veja.abril.com.br/coluna/radar/a-venda-milionaria-de-purificadores-de-agua-no-inicio-de-janeiro/",
      "datePublished": "2023-11-09",
      "publisher": {
       "@type": "Organization",
       "name": "Veja",
       "url": "https://veja.abril.com.br"
      },
      "mentions": {
       "@id": "https://everest.ind.br/#organization"
      }
     }
    },
    {
     "@type": "ListItem",
     "position": 6,
     "item": {
      "@type": "NewsArticle",
      "name": "Everest apresenta novo posicionamento e identidade visual",
      "url": "https://propmark.com.br/everest-apresenta-novo-posicionamento-e-identidade-visual/",
      "datePublished": "2023-11-09",
      "publisher": {
       "@type": "Organization",
       "name": "Propmark",
       "url": "https://propmark.com.br"
      },
      "mentions": {
       "@id": "https://everest.ind.br/#organization"
      }
     }
    }
   ]
  }
 ]
}
